<template>
  <i-button
    size="small"
    class="btn-convert"
    :class="[status.state, { error: status.error, view_only: item.view_only === 1 || status.f_auto_conv === 1 }]"
    @click="onClickConvertStatus(id, item.shop_id, status.portal_site_cd, status.state, item.view_only, status)"
    :loading="status.loading"
    :disabled="isConvertStatusDisabled"
  >
    {{ status.portal_site_name }}
  </i-button>
</template>

<script>
import { Button } from 'view-design'
import { SEND_TYPE_CP } from '@/constants/portal_site'
export default {
  components: {
    'i-button': Button,
  },
  props: {
    id: {
      type: Number,
      default: null,
      required: true,
    },
    item: {
      type: Object,
      default: () => {},
      required: true,
    },
    status: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  computed: {
    isCpSite() {
      return this.status.send_type === SEND_TYPE_CP
    },
    // @notice 高速送信サイトは実送信を伴わない台帳上の手動管理のため、送信不可の物件でも操作を許可する
    isConvertStatusDisabled() {
      return this.status.send_disabled && !this.isCpSite
    },
  },
  methods: {
    // コンバートボタン クリック処理
    onClickConvertStatus(id, shopId, siteCd, state, viewOnly, status) {
      this.$emit('convert', id, shopId, siteCd, state, viewOnly, status)
    },
  },
}
</script>

<style lang="scss" scoped></style>
